import React, {useEffect, useState, useRef} from 'react';
import {Box, Spinner, useDimensions} from '@chakra-ui/react';
import PortfolioHero from './Portfolio/Components/hero';
import PortfolioNav from './Portfolio/Components/nav';
import PortfolioList from './Portfolio/Components/List';
import PortfolioDescription from './Portfolio/Components/description';
import axios from "axios";
import {useParams} from "react-router-dom";
import {SEO} from "../components/SEO";
import {useRecoilState, useSetRecoilState} from "recoil";
import {companiesState} from "../states";

let portfolioDetailData = null;

const PortfolioPage = () => {
    const [companiesData] = useRecoilState(companiesState)
    const [pageData, setPageData] = useState(undefined)
    const {slug} = useParams();
    const pageRef = useRef();

    const dimen = useDimensions(pageRef, true);

    useEffect(() => {
        // console.log('PortfolioDetail 1', window.performance.memory.usedJSHeapSize);
        const abortController = new AbortController();
        const fetchPageData = async () => {
            if(!portfolioDetailData) {
                portfolioDetailData = await axios.get('/wp-json/wp/v2/pages?acf_format=standard&slug=companies', {signal: abortController.signal}).then(resp => {
                    return resp.data;
                });
            }
            if (portfolioDetailData?.length > 0 && portfolioDetailData[0]) {
                setPageData(portfolioDetailData[0])
            }
        }
        fetchPageData()
        return () => {
            abortController.abort();
        }
    }, [slug])

    const isMobile = dimen?.contentBox.width < 768;

    return (
        <>
            {pageData?.yoast_head_json?.og_title &&
                <SEO
                    image={pageData?.yoast_head_json?.og_image?.length > 0 && pageData?.yoast_head_json?.og_image[0]?.url}
                    title={pageData?.title?.rendered}
                    ogTitle={pageData?.yoast_head_json?.og_title}
                    description={pageData?.yoast_head_json?.og_description}
                    url={pageData?.yoast_head_json?.og_url}
                    type={pageData?.yoast_head_json?.og_type}
                    siteName={pageData?.yoast_head_json?.og_site_name}
                    robots={`${pageData?.yoast_head_json?.robots.index}, ${pageData?.yoast_head_json?.robots.follow}`}
                />
            }
            <Box px={['5', '10']}>
                <PortfolioHero/>
                <PortfolioNav/>
                {(!companiesData || companiesData.length < 1) ?
                    (
                        <Box my={20}>
                            <Spinner color='blue.600' size='xl'/>
                        </Box>
                    )
                    :
                    (<>
                        <PortfolioList companies={companiesData}/>
                        <PortfolioDescription/>
                    </>)
                }
            </Box>
        </>
    );
};

export default PortfolioPage;
